import React from 'react';

const TableHeadings = () => (
  <div className="row hidden-lte-sm mock-table-row header">
    <div className="col-lg-3 col-md-4 grid-header sm dark">
      <div className="row">
        <div className="col-xs-offset-2 col-xs-10">
          FACILITY
        </div>
      </div>
    </div>
    <div className="col-lg-5 col-md-6">
      <div className="row">
        <div className="col-xs-4 grid-header sm dark">START</div>
        <div className="col-xs-offset-1 col-xs-4 grid-header sm dark">END</div>
        <div className="col-xs-3 grid-header sm dark padding-0">TOTAL</div>
      </div>
    </div>
    <div className="col-lg-2 hidden-lte-md grid-header sm dark">PURCHASED DATE</div>
  </div>
);

export default TableHeadings;
